import {createFileRoute, Outlet, useLocation, useNavigate} from '@tanstack/react-router'
import {Container, Tabs, Title} from "@mantine/core";
import {IconCheck, IconPackage, IconPlus} from "@tabler/icons-react";

export const Route = createFileRoute("/_authenticated/orders/_layout")({
  component: RouteComponent,
})

function RouteComponent() {
	const navigate = useNavigate()
	const path = useLocation({select: (state)=>state.pathname})
	const value = path.replace("/orders", "").replace("/","")

	return(
		<Container px={0} fluid>
			<Title style={{align: "center"}}> Objednávky </Title>
			<Tabs
				value={value ?? "new"}
				onChange={(value: "new"|"ready"|"delivered"|string|null)=>navigate({to: `/orders/${value}`})}
			>
				<Tabs.List>
					<Tabs.Tab value={"new"} leftSection={<IconPlus />}>Nové</Tabs.Tab>
					<Tabs.Tab value={"ready"} leftSection={<IconPackage />}>Vychystané</Tabs.Tab>
					<Tabs.Tab value={"delivered"} leftSection={<IconCheck />}>Archiv</Tabs.Tab>
				</Tabs.List>
				<Outlet />
			</Tabs>
		</Container>
	)
}
